import script from "./HumanComputerInteractionView.vue?vue&type=script&setup=true&lang=js"
export * from "./HumanComputerInteractionView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__